export default __webpack_public_path__ + "static/logo-48e317b0a55f0a4826baab34e3186f89.png";